export default __webpack_public_path__ + "static/secondbatch-1ae2ceffa00f1e0fd51dcf7e5e4e2685.png";